import * as React from 'react';
import { cn } from '../../lib/utils';

interface ResizeHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
  isResizing: boolean;
  side?: 'left' | 'right';
}

export function ResizeHandle({
  onMouseDown,
  isResizing,
  side = 'left'
}: Readonly<ResizeHandleProps>): React.ReactElement {
  return (
    <button
      type='button'
      tabIndex={-1}
      aria-label='Resize panel'
      className={cn(
        'group/resize absolute top-0 bottom-0 w-3 cursor-ew-resize z-10',
        'focus:outline-none focus-visible:outline-none',
        side === 'left' ? 'left-0' : 'right-0'
      )}
      onMouseDown={onMouseDown}
    >
      <span
        className={cn(
          'absolute top-0 bottom-0 w-1',
          'transition-opacity duration-150',
          'opacity-0 group-hover/resize:opacity-100',
          isResizing && 'opacity-100',
          'bg-brand-light',
          side === 'left' ? 'left-0' : 'right-0'
        )}
      />
    </button>
  );
}

export default ResizeHandle;
